<div
    class="row-container"
    [ngbPopover]="tooltipTemplate"
    [openDelay]="300"
    [closeDelay]="300"
    triggers="mouseenter:mouseleave"
    container="body"
    popoverClass="rask-icon-popover"
>
    <i class="fal fa-sm fa-ball-pile icon" aria-hidden="true"></i>
    <span class="w-100">{{input.naturalKey}} - {{input.title}}</span>
</div>
